/* eslint-disable camelcase */

import type { BaseTableResultItem, TableResult } from "@tanstack/react-table";

import sharedConstants from "@lib/shared_constants.json";

export interface AppsApiLimitsCompanySdkRateLimitDatatableParams {
  /** the unique identifier for the current app group */
  appGroupId: string;
  /** the query object containing all the filters */
  query?: Partial<Record<string, string | string[]>>;
  /** the groupby column */
  groupby?: string;
  /** the number of records to return per page */
  limit?: number;
  /** the column on which to sort */
  sortby?: string;
  /** the direction in which to sort */
  sortdir?: -1 | 1;
  /** the index for the first record in the set among the entire response */
  start?: number;
}

const LIMIT_TYPES = sharedConstants.API_LIMITS.TYPE;
// Type is union of LIMIT_TYPES values
export type RateLimitType = (typeof LIMIT_TYPES)[keyof typeof LIMIT_TYPES];

export interface AppsApiLimitsCompanySdkRateLimitDatatableResultItem extends BaseTableResultItem {
  id: string;
  endpoints: string[];
  rate_limit: {
    limit: number;
    period: number;
  };
  type: RateLimitType;
  last_changed_timestamp: string;
}

export type AppsApiLimitsCompanySdkRateLimitDatatableResult =
  TableResult<AppsApiLimitsCompanySdkRateLimitDatatableResultItem>;
